import { loadTrack } from './tracks';

const loadTrackList = (trackList, live, namespace = null) => {
    const tracks = [];

    // we want to order the tracks based on trackList[0].type
    // we want Chronos to be last so that it is rendered above all others
    const orderedTrackList = [];
    if(!trackList || !trackList.length){
        return tracks;
    }
    const chronosTracks = trackList.filter(t => t.type === 'chronos');
    const otherTracks = trackList.filter(t => t.type !== 'chronos');
    orderedTrackList.push(...otherTracks);
    orderedTrackList.push(...chronosTracks);

    for(let trackIndx = 0; trackIndx < orderedTrackList.length; trackIndx++){
        tracks.push(loadTrack(orderedTrackList[trackIndx], live, namespace));
    }
    
    return tracks;
}

const loadTracksFromData = (dataSet, live) => {
    const tracks = [];
    
    const showExperimentalData = localStorage.getItem('showExperimentalData') === 'true';
    if (showExperimentalData) {
        const experimentalTrackData = dataSet['experimentalData'];
        tracks.push(...loadTrackList(experimentalTrackData, live, 'experimental'));
    }

    const showRidData = true;
    if (showRidData) {
        const ridDataTracks = dataSet['ridData'];
        tracks.push(...loadTrackList(ridDataTracks, live, 'rid'));
    }

    const trackData = dataSet['pointdata'];
    tracks.push(...loadTrackList(trackData, live));
    
    return tracks;
};
  
export const loadPoints = (flightData, clearAll = false, flyToStart = false, live = false) => {
    console.log('loadPoints: flightData', flightData, 'clearAll', clearAll, 'flyToStart', flyToStart, 'live', live);
    
    // This is not used for now
    // if (clearAll) {
    //     console.log('clearing all stores');
    //     clearAllStores();
    // }

    const res = flightData.map((dataSet) => loadTracksFromData(dataSet, live));

    return res;
}
